<div class="grid">
	<div class="col-12 flex align-items-center justify-content-end">
		<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
			<i class="pi cm-search"></i>
			<input [formControl]="searchFilter" pInputText type="text" id="helper-input-search-guest-dialog"
				placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputTextWidth()" maxlength="254" />
		</span>
	</div>
</div>
<div *ngIf="filter===''">
	<app-helper-list [controller]="false"></app-helper-list>
</div>
<div *ngIf="filter!==''" class="grid">
	<p-accordion (click)="accordionAction()" class="col-12">
		<p-accordionTab *ngFor="let subsection of helpSearchList;">
			<ng-template pTemplate="header">
				<div class="py-0"><span class="font-bold white-space-nowrap">{{subsection.Title}}</span></div>
			</ng-template>
			<app-helper-subsection [subsection]="subsection" [controller]="false"></app-helper-subsection>
		</p-accordionTab>
	</p-accordion>
</div>

<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
	<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
		class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
	</button>
</div>